<template>
    <div >
       <div ref="map" style="width:100%; height:400px; border-radius: 10px;"></div>
    </div>
</template>

<script src="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyCvaQ7aJb06v2TC-1oOcGmUXXUsU1dFW9I"></script>

<script>
import {EventBus} from "@/events/event-bus";
import Vue from "vue";
require("eon-map")

export default {
  name: "BookingViewMap",

  props: {
    itemType: {
      type: String,
      required: false
    },
    bookingId: {
      type: Number,
      required: false,
        default() {
            return 0
        }
    },
    availableContractors: {
      type: Array,
      required: false,
      default() {
          return []
      }
    },
    lineAddress: {
      type: Array,
      required: false,
        default() {
            return []
        }
    },
    bookingAddress: {
      type: Array,
      required: false,
        default() {
            return []
        }
    },
    showAddress: {
      required: false
    },
  },
  data() {
    return {
        addresses:[],
        map:[],
        infoWindows:[],
        lineAddressData : this.lineAddress,
        bookingAddressData : this.bookingAddress,
        availableContractorsData : this.availableContractors,
    }
  },
  computed: {

  },
  methods: {
      getBookingAddressParams(){
          let url = `webservice/get-booking-google-map-params/${this.bookingId}`;
          axios.get(url).then( response => {
            this.addresses = [];
            this.lineAddressData = response.data.data.lineAddress;
            this.bookingAddressData = response.data.data.bookingAddressArr;
            this.availableContractorsData = response.data.data.availableContractorsByStateArr;
            this.initMap();
          });

      },
    initMap(){
        var myOptions=[];
        //get Addresses
        this.getBookingAddresses();
        myOptions = {
            zoom: 9,
            //center: new google.maps.LatLng(-34.397, 150.644),
            draggable: true,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_CENTER
            },
            mapTypeId: google.maps.MapTypeId.MyMapApp
        }
        this.map = new google.maps.Map(this.$refs.map, myOptions);
        this.drawBookingAddresses();
        this.drawContractorsMarkers();
      this.map.addListener('click', () => {
        this.closeAllInfoWindowsOnGoogleMap();
        this.showMapControls();
      });
    },
    getBookingAddresses(){
        this.lineAddressData.forEach((address, index) => {
            this.addresses.push({
                address :address.text_address,
                label : this.bookingAddressData[index].marker_label ,
                lon: address.address_lon,
                lat: address.address_lat,

            })
        });
    },
    drawBookingAddresses() {
          let geocoder2 = new google.maps.Geocoder();
          let icon = 'http://maps.google.com/mapfiles/ms/icons/orange-dot.png';
          this.addresses.forEach((address, index) => {
              if (index == 0) {
                  icon = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
              }
              var latlng2 = new google.maps.LatLng(address['lat'], address['lon']);
              var displayedAddress = address['address'];
              if (address['lat'] == 0 || address['lon'] == 0) {
                  geocoder2.geocode({ 'address': address['address'] }, (results, status) => {
                      /**
                       * check if google response is OK
                       */
                      if (status == google.maps.GeocoderStatus.OK) {
                          latlng2 = results[0].geometry.location;
                          displayedAddress = results[0].formatted_address;
                          this.setBookingAddressMarker(this.map, latlng2, displayedAddress, icon, index);
                      } else {
                          var country = displayedAddress;
                          geocoder2.geocode({ 'address': country }, (results, status) => {
                              if (status == google.maps.GeocoderStatus.OK) {
                                  this.map.setCenter(results[0].geometry.location);
                              }
                          });
                      }
                  });
              } else {
                  this.setBookingAddressMarker(this.map, latlng2, displayedAddress, icon, index);
              }
          });
      },
    drawContractorsMarkers(){
        let vm = this;
        let markerIcon = '/Images/icons/marker-highlight.svg'
      console.log("Mostafa")
        google.maps.event.addListenerOnce(this.map, 'idle', function() {
          console.log("Entered")
            if(vm.availableContractorsData.length){
console.log("len")
                var oms = new OverlappingMarkerSpiderfier(vm.map, {
                    markersWontMove: true,
                    markersWontHide: true,
                    keepSpiderfied:true
                });
                oms.addListener('format', function(marker, status) {
                    var markerIcon = status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIED ? '/Images/icons/marker-highlight.svg' :
                        status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE ? '/Images/icons/marker-plus.svg' :
                            status == OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIABLE ? '/Images/icons/marker.svg' :
                                null;
                    if(markerIcon!==null){
                        marker.setIcon({
                            url: markerIcon,
                            scaledSize: new google.maps.Size(23, 32) // makes SVG icons work in IE
                        });
                    }
                });
                vm.availableContractorsData.forEach((contractor, index) => {
                  console.log(contractor)
                    let userId = contractor.user_id
                    let lat = contractor.lat_lon.lat
                    let lon = contractor.lat_lon.lon
                    var contractorLatLng = new google.maps.LatLng(lat,lon);
                    // if($.inArray(contractorLatLng,bookingAddressLatLng)){
                    //     contractorLatLng = new google.maps.LatLng(contractorLatLng.lat()-0.01,contractorLatLng.lng()+0.01);
                    // }


                    var marker = new google.maps.Marker({
                        position: contractorLatLng

                    });

                    google.maps.event.addListener(marker, 'spider_click', function(e) {  // 'spider_click', not plain 'click'
                        var infowindow = new google.maps.InfoWindow({
                            content: '<span idstyle="text-align:center"><img src="/pic/loading-4.gif"></span></span>',
                            maxWidth: 282,
                            maxheight: 600,
                            padding: 0
                        });
                        infowindow.open(this.map, marker);
                      google.maps.event.addListener(infowindow, 'domready', function() {
                        // Hide map controls
                        vm.map.setOptions({
                          // zoomControl: false,
                          streetViewControl: false,
                          mapTypeControl: false
                          // other controls to hide
                        });
                      });

                      // When the InfoWindow's close button is clicked
                      google.maps.event.addListener(infowindow, 'closeclick', function() {
                        // Show map controls
                        vm.showMapControls()
                      });
                        $.ajax({
                            type:"POST",
                            url: "/contractor-details",
                            data: 'contractor_id=' + userId + '&row=' + JSON.stringify(vm.availableContractors) +`&itemId=${vm.bookingId}&itemType=booking`,
                            success:function(data){
                                $('.gm-style-iw-d').css('overflow', 'unset');
                                $('.gm-style-iw').css('overflow', 'unset');
                                infowindow.setContent(data);
                                vm.infoWindows.push(infowindow);
                                vm.closeAllInfoWindowsOnGoogleMap();
                                infowindow.open(vm.map, marker);
                                vm.map.addListener('click', function () {
                                    infowindow.close();
                                });
                            }
                        });
                    });
                    oms.addMarker(marker);
                });
            }
        });
    },
    showMapControls() {
      this.map.setOptions({
        // zoomControl: true,
        streetViewControl: true,
        mapTypeControl: true
        // ... other controls ...
      });
    },
    setBookingAddressMarker(map,latlng2,displayedAddress,icon,counter){
        let vm = this;

        var infowindow = new google.maps.InfoWindow({
            content: "<div style='padding: 12px;'>" +
                "<p> "+displayedAddress+"</p>" +
                "</div>"
        });
        var marker = new google.maps.Marker({
            map: vm.map,
            position: latlng2
        });
        vm.map.setCenter(latlng2);
        marker.setIcon(icon);
        marker.addListener('click', function() {
              infowindow.open(vm.map, marker);
        });
        if(counter == 0){
            vm.map.addListener('click', function() {
                vm.map.setCenter(latlng2);
                infowindow.open(vm.map,marker);
            });
        }

      },
      closeAllInfoWindowsOnGoogleMap() {
        let vm = this;
          for (var i=0;i<vm.infoWindows.length;i++) {
              vm.infoWindows[i].close();
          }
      }
  },
  mounted() {
    this.availableContractorsData = this.availableContractors
      if(this.itemType == 'booking'){
          this.getBookingAddressParams();
      }else{
          this.initMap();
      }

        // this.initMap();
      EventBus.$on('updateBookingLocationsOnGoogleMap', () => {
          this.getBookingAddressParams();
      })
  },
  watch:{

  }
}
</script>

<style scoped>

</style>